import { render, staticRenderFns } from "./ItemContextMenu.vue?vue&type=template&id=53222e1a&"
import script from "./ItemContextMenu.vue?vue&type=script&lang=js&"
export * from "./ItemContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports